import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router';

import { ROUTES } from '@constants/routes';

const ShareResultsCard = () => {
  const navigate = useNavigate();

  const onShareResults = () => {
    navigate(ROUTES.SHARE_RESULTS);
  };

  return (
    <section className='bg-light-blue p-3 rounded-4' data-testid='shareResultsCard'>
      <p className='fs-sm fw-semibold font-family-custom mb-2'>Share Results</p>
      <p className='fs-xs mb-3'>Email a copy of your results to your healthcare provider or family member.</p>
      <Button size='sm' className='btn btn-primary text-nowrap' onClick={onShareResults}>
        Share
      </Button>
    </section>
  );
};

export default ShareResultsCard;
